<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Cérémonie Académique" />
        <CeremonieAcademique/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import CeremonieAcademique from './CeremonieAcademique.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        CeremonieAcademique,
        FooterComp,
    }
}
</script>